import { render, staticRenderFns } from "./Func31Detalhe.vue?vue&type=template&id=d07a6f16"
import script from "./Func31Detalhe.vue?vue&type=script&lang=js"
export * from "./Func31Detalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports